export default __webpack_public_path__ + "static/mongodb-16cf72279f49cb5980cc97399caa376f.png";